import React, { useState, useEffect, useRef } from 'react';
import SatTab from '@components/common/satUI/SatTab';
import SatButton from '@components/common/satUI/SatButton';
import {
  SimulationPolicyChange,
  SimulationRpuSurrender,
  SimulationReverseMortgage,
  SimulationGiaPayment,
  SimulationLifeCare,
  SimulationOldIncome,
  SimulationAnnuityInAdvance,
  SimulationUniversialRider,
  AdditionalPayment,
  AnnuityExample,
  SilverNursingCareRider,
  AnnuityRider1,
  AnnuityRider2,
  AnnuityRider4,
} from '@components/simulation/new';

const Footer = ({ children }) => {
  return (
    <div className="con-bottom">
      <div className="btn-area">
        <div className="box-btns-center">{children}</div>
      </div>
    </div>
  );
};

const TAB_NAME = Object.freeze({
  연금액예시: '2',
  실버널싱케어특약: '24',
  추가납입예시_연금선지급: '25',
  계약변경시_연금월액: '27',
  감액완납시_해약환급금: '11',
  역모기지특약: '23',
  노후소득보증금예시: '13',
  라이프케어보험금: '19',
  연금선지급서비스: '30',
  노후소득선지급: '31',
  연금전환특약: '5',
  유니버셜특약: '22',
  달러유니버셜특약: '20',
});

const SimulationList = props => {
  const { simulationInfo, onClose } = props;
  const [activeTab, setActiveTab] = useState('');

  const [tabDatas, setTabDatas] = useState([]);
  const [isDisabled, setDisabled] = useState(false);

  const calcRef = useRef();

  useEffect(() => {
    if (simulationInfo.isVisible && simulationInfo.simulationList.length > 0) {
      let tabInfos = simulationInfo.simulationList.map(o => {
        const tabInfo = {
          label: o.simlKorNm,
          value: o.simlNm,
          styleClass: o.simlNm === '11' ? 'flex-none w-180' : 'flex-none w-154',
        };
        return tabInfo;
      });

      setTabDatas(tabInfos);
      const tabToActivate =
        activeTab || simulationInfo.simulationList[0].simlNm;
      setActiveTab(tabToActivate);

      let activeSimulInfo = simulationInfo.simulationList.find(
        item => item.simlNm == activeTab,
      );
      activeSimulInfo && setDisabled(false);
    }
  }, [simulationInfo]);

  //계산하기 버튼 활성화 컨트롤
  useEffect(() => {
    let isCalc = false;
    if (calcRef.current && calcRef.current.checkValid) {
      isCalc = calcRef.current.checkValid();
    }
    setDisabled(!isCalc);
  }, [
    activeTab,
    simulationInfo.additionalPaymentInfo,
    simulationInfo.CsvForRpu,
  ]);

  const tabPaneRender = value => {
    switch (value) {
      case TAB_NAME.연금액예시:
        return (
          <AnnuityExample
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.실버널싱케어특약:
        return (
          <SilverNursingCareRider
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.추가납입예시_연금선지급:
        return (
          <AdditionalPayment
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.계약변경시_연금월액:
        return (
          <SimulationPolicyChange
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.감액완납시_해약환급금:
        return (
          <SimulationRpuSurrender
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.역모기지특약:
        return (
          <SimulationReverseMortgage
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.노후소득보증금예시:
        return (
          <SimulationGiaPayment
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.라이프케어보험금:
        return (
          <SimulationLifeCare
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.연금선지급서비스:
          return (
            <SimulationAnnuityInAdvance
              simulationInfo={simulationInfo}
              ref={calcRef}
              type={value}
            />
         );        
      case TAB_NAME.노후소득선지급:
        return (
          <SimulationOldIncome
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.유니버셜특약:
      case TAB_NAME.달러유니버셜특약:
        return (
          <SimulationUniversialRider
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      case TAB_NAME.연금전환특약:
        return simulationInfo.productInfo.productDetail
          .joinTmiAnutyConvExmpYn === 'Y' ? (
          <AnnuityRider1
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        ) : (
          <AnnuityRider2
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      // 연금전환특약
      case '32':
      case '33':
      case '34':
      case '35':
      case '38':
      case '37':
        return (
          <AnnuityRider4
            simulationInfo={simulationInfo}
            ref={calcRef}
            type={value}
          />
        );
      default:
        return <></>;
    }
  };

  const handleActiveTab = value => {
    setActiveTab(value);
  };

  return (
    <>
      <header className="con-header">
        <div className="page-navi">
          <span onClick={onClose} className="btn-back">
            이전
          </span>
        </div>
        <h1 className="page-tit">시뮬레이션</h1>
      </header>

      <div className="con-wrap">
        <div className="pop-box w-830">
          <div className="tab-wrap d-flex-column h-full">
            <SatTab
              activeTab={activeTab}
              onChange={handleActiveTab}
              customStyleClass={'tab-nav tab-type2'}
            >
              {tabDatas.map(tabData => (
                <SatTab.TabPane
                  key={tabData.value}
                  className="flex-full"
                  tab={tabData}
                >
                  {activeTab === tabData.value && tabPaneRender(tabData.value)}
                </SatTab.TabPane>
              ))}
            </SatTab>
          </div>
        </div>
      </div>

      <Footer>
        <SatButton
          styleClass={'btn-s blue btn-wide'}
          disabled={isDisabled}
          label="계산하기"
          onClick={() => {
            calcRef.current.calc();
          }}
        />
      </Footer>
    </>
  );
};

export default SimulationList;
